
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Tag, Trash2 } from 'lucide-react';
import { DeviceGroup } from './useDeviceGroups';

interface DeviceGroupsTableProps {
  groups: DeviceGroup[];
  editing: boolean;
  onDelete: (id: string) => void;
}

const DeviceGroupsTable: React.FC<DeviceGroupsTableProps> = ({ groups, editing, onDelete }) => {
  return (
    <div className="border rounded-md">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Group Name</TableHead>
            <TableHead>Type</TableHead>
            <TableHead>Department</TableHead>
            <TableHead>Devices</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {groups.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} className="text-center py-6">
                <div className="flex flex-col items-center justify-center text-muted-foreground">
                  <Tag className="h-8 w-8 mb-2" />
                  <p>No device groups found</p>
                </div>
              </TableCell>
            </TableRow>
          ) : (
            groups.map((group) => (
              <TableRow key={group.id}>
                <TableCell className="font-medium">
                  <div className="flex items-center">
                    <Tag className="h-4 w-4 mr-2 text-primary" />
                    {group.name}
                  </div>
                </TableCell>
                <TableCell>
                  <Badge variant="outline">{group.type}</Badge>
                </TableCell>
                <TableCell>{group.department}</TableCell>
                <TableCell>{group.deviceCount} devices</TableCell>
                <TableCell className="text-right">
                  <Button 
                    variant="ghost" 
                    size="sm" 
                    className="text-destructive hover:text-destructive/90 hover:bg-destructive/10"
                    onClick={() => onDelete(group.id)}
                    disabled={!editing}
                  >
                    <Trash2 className="h-4 w-4" />
                    <span className="sr-only">Delete</span>
                  </Button>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default DeviceGroupsTable;
